import {Component, OnInit} from '@angular/core';
import {UserService} from "../../services/user/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import Swal from "sweetalert2";

@Component({
  selector: 'app-otp-page',
  templateUrl: './otp-page.component.html',
  styleUrls: ['./otp-page.component.scss']
})
export class OtpPageComponent implements OnInit {
  email?: string
  otp?: string;

  constructor(public userService: UserService, private activedRouter: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit(): void {
    this.email = this.activedRouter.snapshot.queryParamMap.get('email') ?? '';
    }

  async confirmOtp() {

    if (!this.email) return;
    if (!this.otp) return;

    let response = await this.userService.checkOTP(this.otp, this.email);

    if (response.success) {
      Swal.fire({
        icon: 'success',
        title: 'Congratulazioni! Abbiamo preso in carico la tua registrazione.',
        text: 'La società sportiva si riserva la possibilità di\n' +
            '                        accettare o meno l\'iscrizione delgli atleti indicati, vi invieremo una notifica\n' +
            '                        via\n' +
            '                        email con l\'esito della verifica.'
      });
      this.router.navigate(['/login'])
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Errore durante la procedura di registrazione',
      });
    }
  }

}
